import { useEffect, useState } from 'react';
import { useGetCounterparties } from 'api/counterparties';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { Counterparty } from 'pages/invoices/invoices.types';
import { handleChange } from 'utils/form.utils';
import { CounterpartyOption } from './CounterpartySelect';

type Props = {
  value: CounterpartyOption | null;
  onChange: (value: CounterpartyOption | null) => void;
  error?: boolean;
};

export const CounterpartyAutocomplete = ({ value, onChange, error }: Props) => {
  const [options, setOptions] = useState<Counterparty[]>([]);
  const [params, setParams] = useState({
    filterText: '',
    pageNumber: 1,
    resultSize: 25,
  });

  const { getCounterparties, loading, counterpartiesData } =
    useGetCounterparties();

  useEffect(() => {
    getCounterparties(params);
  }, [getCounterparties, params]);

  useEffect(() => {
    if (counterpartiesData?.length) {
      setOptions((prev) => [
        ...prev,
        ...counterpartiesData.filter((cp) => cp.enabled),
      ]);
    }
  }, [counterpartiesData]);

  const handleBlur = () => {
    setParams({ filterText: '', pageNumber: 1, resultSize: 25 });
    setOptions([]);
  };

  return (
    <AutocompletePaginationAsync
      value={value}
      options={options}
      loading={loading}
      padding='dense'
      disableClearable
      error={error}
      getOptionLabel={(option) => (option as Counterparty).code}
      isOptionEqualToValue={(option, val) =>
        (option as Counterparty).id === (val as CounterpartyOption).id
      }
      onChange={(_, v) => onChange(v as CounterpartyOption | null)}
      onBlur={handleBlur}
      handleSearchChange={handleChange(setOptions, setParams)}
      onScrollBottom={() =>
        setParams((prev) => ({ ...prev, pageNumber: prev.pageNumber + 1 }))
      }
    />
  );
};
